/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate ,react/sort-comp */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-prototype-builtins ,react/jsx-no-bind  , react/jsx-boolean-value*/
import React from 'react';
// import TextAreaAutosize from 'react-textarea-autosize';
import {
  ContentState, EditorState, convertFromHTML, convertToRaw,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { Editor } from 'react-draft-wysiwyg';

import DynamicOptionList from './DynamicOptionList';
// import { get } from './stores/requests';
// import ID from './UUID';
// import IntlMessages from './language-provider/IntlMessages';



const styles = {
  headingBox: {
    marginBottom: '2rem',
    marginTop: '2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px dashed #333',
    paddingBottom: '2rem',
  },
  heading: {
    color: '#333333',
    margin: '0px 0px 0px 0px',
    fontSize: '2rem',
    fontFamily: ' VodafoneRg-Bold',
    lineHeight: 1
  },
  closeIcon: {
    color: '#333333',
    margin: '0px 0px 0px 0px',
    fontSize: '1.125rem',
    fontFamily: ' VodafoneRg-bold',
  },
  labels: {
    color: '#333',
    fontSize: '1.125rem',
    fontFamily: 'VodafoneRg-bold',
    marginBottom: '1rem',
    display: 'inline-block'
  },
  inputs: {
    width: '100%',
    minHeight: '2.8rem',
    padding: '0.5rem',
    boxSizing: 'border-box',
    fontSize: '1rem',
    fontFamily: 'VodafoneRg-Regular',
  }
}


const toolbar = {
  options: ['inline', 'list', 'textAlign', 'fontSize', 'link', 'history'],
  inline: {
    inDropdown: false,
    className: 'custom-toolbox',
    options: ['bold', 'italic', 'underline', 'superscript', 'subscript'],
  },
};

function ConvertFromHTML(content) {
  const newContent = convertFromHTML(content);
  if (!newContent.contentBlocks || !newContent.contentBlocks.length) {
    // to prevent crash when no contents in editor
    return EditorState.createEmpty();
  }
  const contentState = ContentState.createFromBlockArray(newContent);
  return EditorState.createWithContent(contentState);
}


export default class FormElementsEdit extends React.Component {
  constructor(props) {
    console.log("props======formelement-edit", props)
    super(props);
    this.state = {
      element: this.props.element,
      data: this.props?.data,
      dirty: false,
    };
  }



  // toggleRequired() {
  //   const this_element = this.state.element;
  // }



  onEditorStateChange(index, property, editorContent) {
    console.log("index", index)
    console.log("property", property)
    console.log("editorContent", editorContent)
    // const html = draftToHtml(convertToRaw(editorContent.getCurrentContent())).replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
    const html = draftToHtml(convertToRaw(editorContent.getCurrentContent())).replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/&nbsp;/g, ' ')
      .replace(/(?:\r\n|\r|\n)/g, ' ');
    const this_element = this.state.element;
    // console.log("this_element",this_element)
    this_element[property] = html;
    // console.log(" this_element[property]", html)

    this.setState({
      element: this_element,
      dirty: true,
    });
  }

  editElementProp(elemProperty, targProperty, e) {
    // console.log('editElementProp===>',e)
    // elemProperty could be content or label
    // targProperty could be value or checked
    const this_element = this.state.element;
    this_element[elemProperty] = e.target[targProperty];

    this.setState({
      element: this_element,
      dirty: true,
    }, () => {
      if (targProperty === 'checked') { this.updateElement(); }
    });
  }

  updateElement() {
    const this_element = this.state.element;
    console.log("this_element", this_element)
    // to prevent ajax calls with no change
    if (this.state.dirty) {
      this.props.updateElement.call(this.props.preview, this_element);
      this.setState({ dirty: false });
    }
  }


  // addOptions() {
  //   const optionsApiUrl = document.getElementById('optionsApiUrl').value;
  //   if (optionsApiUrl) {
  //     get(optionsApiUrl).then(data => {
  //       this.props.element.options = [];
  //       const { options } = this.props.element;
  //       data.forEach(x => {
  //         // eslint-disable-next-line no-param-reassign
  //         x.key = ID.uuid();
  //         options.push(x);
  //       });
  //       const this_element = this.state.element;
  //       this.setState({
  //         element: this_element,
  //         dirty: true,
  //       });
  //     });
  //   }
  // }

  render() {
    console.log(' this.state.data =====>', this.state.data)
    console.log(' this.props.element [][][]=====>', this.props.element, 'all props', this.props)
    if (this.state.dirty) {
      this.props.element.dirty = true;
    }

    const this_checked = this.props.element.hasOwnProperty('required') ? this.props.element.required : false;
    const this_checked_tooltips = this.props.element.hasOwnProperty('tooltips') ? this.props.element.tooltips : false;
    const this_checked_overAll_Weight = this.props.element.hasOwnProperty('weight_required') ? this.props.element.weight_required : false;
    const this_checked_leftLabel = this.props.element.hasOwnProperty('leftLabel') ? this.props.element.leftLabel : false;
    const this_checked_centerLabel = this.props.element.hasOwnProperty('centerLabel') ? this.props.element.centerLabel : false;
    const this_checked_rightLabel = this.props.element.hasOwnProperty('rightLabel') ? this.props.element.rightLabel : false;
    
    const this_checkedFailEffect = this.props.element.hasOwnProperty('failEffect') ? this.props.element.failEffect : "None";
    // const this_checkedNone = this.props.element.hasOwnProperty('none') ? this.props.element.none : false;
    const this_read_only = this.props.element.hasOwnProperty('readOnly') ? this.props.element.readOnly : false;
    const this_default_today = this.props.element.hasOwnProperty('defaultToday') ? this.props.element.defaultToday : false;
    const this_show_time_select = this.props.element.hasOwnProperty('showTimeSelect') ? this.props.element.showTimeSelect : false;
    const this_show_time_select_only = this.props.element.hasOwnProperty('showTimeSelectOnly') ? this.props.element.showTimeSelectOnly : false;
    const this_show_time_input = this.props.element.hasOwnProperty('showTimeInput') ? this.props.element.showTimeInput : false;
    const this_checked_inline = this.props.element.hasOwnProperty('inline') ? this.props.element.inline : false;
    const this_checked_bold = this.props.element.hasOwnProperty('bold') ? this.props.element.bold : false;
    const this_checked_italic = this.props.element.hasOwnProperty('italic') ? this.props.element.italic : false;
    const this_checked_center = this.props.element.hasOwnProperty('center') ? this.props.element.center : false;
    const this_checked_page_break = this.props.element.hasOwnProperty('pageBreakBefore') ? this.props.element.pageBreakBefore : false;
    const this_checked_alternate_form = this.props.element.hasOwnProperty('alternateForm') ? this.props.element.alternateForm : false;

    console.log("this_checkedFailEffect", this_checkedFailEffect)

    // const {
    //   canHavePageBreakBefore, canHaveAlternateForm, canHaveDisplayHorizontal, canHaveOptionCorrect, canHaveOptionValue,
    // } = this.props.element;

    const canHaveImageSize = (this.state.element.element === 'Image' || this.state.element.element === 'Camera');

    const this_files = this.props.files.length ? this.props.files : [];
    if (this_files.length < 1 || (this_files.length > 0 && this_files[0].id !== '')) {
      this_files.unshift({ id: '', file_name: '' });
    }

    let editorState;
    if (this.props.element.hasOwnProperty('content')) {
      // editorState = this.convertFromHTML(this.props.element.content);
      editorState = ConvertFromHTML(this.props.element.content);
    }
    if (this.props.element.hasOwnProperty('label')) {
      // editorState = this.convertFromHTML(this.props.element.label);
      editorState = ConvertFromHTML(this.props.element.label);
    }

    // console.log("this.props.element.hasOwnProperty('label')", this.props.element)
    // console.log('this.props.element.hasOwnProperty(rating',  this.props.element.element === "Rating" )


    return (
      <div>
        <div style={styles.headingBox}>
          <h4 style={styles.heading}>{this.props.element.text}</h4>
          <i
            role='button'
            tabIndex={0}
            style={styles.closeIcon}
            className="float-right fas fa-times dismiss-edit"
            onClick={this.props.manualEditModeOff}
          >Close</i>
        </div>

        {
          this.props.element.hasOwnProperty('content') &&
          <div className="form-group">
            <label style={styles.labels} className="control-label">
              {/* <IntlMessages id="text-to-display" /> */}
              Text to display
              :</label>

            <Editor
              toolbar={toolbar}
              defaultEditorState={editorState}
              onBlur={this.updateElement.bind(this)}
              onEditorStateChange={this.onEditorStateChange.bind(this, 0, 'content')}
              stripPastedStyles={true} />
          </div>
        }
        {/* { this.props.element.hasOwnProperty('file_path') &&
          <div className="form-group">
            <label className="control-label" htmlFor="fileSelect"><IntlMessages id="choose-file" />:</label>
            <select id="fileSelect" className="form-control" defaultValue={this.props.element.file_path} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'file_path', 'value')}>
              {this_files.map((file) => {
                const this_key = `file_${file.id}`;
                return <option value={file.id} key={this_key}>{file.file_name}</option>;
              })}
            </select>
          </div>
        }  */}
        {/* { this.props.element.hasOwnProperty('href') &&
        //   <div className="form-group">
        //     <TextAreaAutosize type="text" className="form-control" defaultValue={this.props.element.href} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'href', 'value')} />
        //   </div>
        } */}

        {/* {
          (this.props.element.key === "MyTextInput") &&
          <div className="form-group">
            <label style={styles.labels}>  Display label  </label>
            <Editor
              toolbar={toolbar}
              defaultEditorState={editorState}
              onBlur={this.updateElement.bind(this)}
              onEditorStateChange={this.onEditorStateChange.bind(this, 0, 'label')}
              stripPastedStyles={true} />
            <br />
            <div className="custom-control custom-checkbox">
              <input id="is-required" className="custom-control-input" type="checkbox" checked={this_checked} value={true} onChange={this.editElementProp.bind(this, 'required', 'checked')} />
              <label style={styles.labels} className="custom-control-label" htmlFor="is-required"> Required  </label>
            </div>
            <div className="custom-control custom-checkbox">
              <input id="is-tooltips" className="custom-control-input" type="checkbox" checked={this_checkedTooltips} value={true} onChange={this.editElementProp.bind(this, 'toolTip', 'checked')} />
              <label style={styles.labels} className="custom-control-label" htmlFor="is-tooltips">  Include tooltip? </label>
              {this.props.element.toolTip && <input style={styles.inputs} type='text' placeholder='Tooltip Summary' defaultValue={this.props.element.toolTipSummary} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'toolTipSummary', 'value')} />}
            </div>
          </div>
        } */}

        {
          (this.props.element.key === "MySpaceComponent") &&
          <div>
            <input style={styles.inputs} type='number' placeholder='Number' defaultValue={this.props.element.heightValue} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'heightValue', 'value')} />
          </div>
        }

        {/* {
          (this.props.element.element === "TextInput") &&
          <div className="form-group">
            <label style={styles.labels}>  Display label  </label>
            <Editor
              toolbar={toolbar}
              defaultEditorState={editorState}
              onBlur={this.updateElement.bind(this)}
              onEditorStateChange={this.onEditorStateChange.bind(this, 0, 'label')}
              stripPastedStyles={true} />
            <br />
            <div className="custom-control custom-checkbox">
              <input id="is-required" className="custom-control-input" type="checkbox" checked={this_checked} value={true} onChange={this.editElementProp.bind(this, 'required', 'checked')} />
              <label className="custom-control-label" htmlFor="is-required"> Required  </label>
            </div>
          </div>
        } */}


        {this.props.element.hasOwnProperty('label') &&
          <div className="form-group">
            <label><h3 id="display-label" > Display Label </h3></label>
            <Editor
              toolbar={toolbar}
              defaultEditorState={editorState}
              onBlur={this.updateElement.bind(this)}
              onEditorStateChange={this.onEditorStateChange.bind(this, 0, 'label')}
              stripPastedStyles={true}
            />
            <br />

            {/* <div className="custom-control custom-checkbox">
              <input id="is-required" className="custom-control-input" type="checkbox" checked={this_checked} value={true} onChange={this.editElementProp.bind(this, 'required', 'checked')} />
              <label style={styles.labels} className="custom-control-label" htmlFor="is-required">
                <span id="required" > Required </span>
              </label>
            </div> */}

          <div className="custom-control custom-checkbox">
                        <input id="is-required" className="custom-control-input" type="checkbox" checked={this_checked} value={true} onChange={this.editElementProp.bind(this, 'required', 'checked')} />
                        <label style={styles.labels} className="custom-control-label" htmlFor="is-required">
                         <span id="required" > Required </span>
                        </label>
                      </div>
                      <div className="custom-control custom-checkbox">
                        <input id="is-tooltip" className="custom-control-input" type="checkbox" checked={this_checked_tooltips} value={true} onChange={this.editElementProp.bind(this, 'tooltips', 'checked')} />
                        <label style={styles.labels} className="custom-control-label" htmlFor="is-tooltip">
                        {/* <IntlMessages id="tooltip" /> */}<span id="tooltip" >  Include tooltip? </span>
                        </label>
                        {this.props.element.tooltips && <input style={styles.inputs} type='text' placeholder='Tooltip Summary' defaultValue={this.props.element.labelTooltip} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'labelTooltip', 'value')} />}
                      </div>
                      


            {/* <div className="custom-control custom-checkbox">
              <input id="is-tooltips" className="custom-control-input" type="checkbox" checked={this_checkedTooltips} value={true} onChange={this.editElementProp.bind(this, 'toolTip', 'checked')} />
              <label style={styles.labels} className="custom-control-label" htmlFor="is-tooltips">  Include tooltip? </label>
              {this.props.element.toolTip && <input style={styles.inputs} type='text' placeholder='Tooltip Summary' defaultValue={this.props.element.toolTipSummary} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'toolTipSummary', 'value')} />}
            </div> */}

            {
              //  (this.props.element.key === "MyTextInput") &&

              //  <div className="form-group">
              //   <div className="custom-control custom-checkbox">
              //     <input id="is-required" className="custom-control-input" type="checkbox" checked={this_checked} value={true} onChange={this.editElementProp.bind(this, 'required', 'checked')} />
              //     <label style={styles.labels} className="custom-control-label" htmlFor="is-required"> Required  </label>
              //   </div>
              //     <div className="custom-control custom-checkbox">
              //       <input id="is-tooltips" className="custom-control-input" type="checkbox" checked={this_checkedTooltips} value={true} onChange={this.editElementProp.bind(this, 'toolTip', 'checked')} />
              //       <label style={styles.labels} className="custom-control-label" htmlFor="is-tooltips">  Include tooltip? </label>
              //       {this.props.element.toolTip && <input style={styles.inputs} type='text' placeholder='Tooltip Summary' defaultValue={this.props.element.toolTipSummary} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'toolTipSummary', 'value')} />}
              //     </div>
              //  </div>
            }


            {/* { (this.state.element.element === 'RadioButtons' || this.state.element.element === 'Checkboxes') && 
              <div className="custom-control custom-checkbox">
                <input id="display-horizontal" className="custom-control-input" type="checkbox" checked={this_checked_inline} value={true} onChange={this.editElementProp.bind(this, 'inline', 'checked')} />
                <label className="custom-control-label" htmlFor="display-horizontal">
                    <span id="display-horizontal" > Display horizontal </span>
                </label>
              </div>
            }  */}

              

                  {(this.state.element.element === 'RadioButtons')   && 
                     
                         <div className="custom-control custom-checkbox overall_weight">
                <input 
                id="is-overall_weight" 
                className="custom-control-input" 
                type="checkbox" 
                checked={this_checked_overAll_Weight} 
                value={true} 
                onChange={
                  // this.editElementProp.bind(this, 'weight_required', 'checked')
                  (e) => {
                    const isChecked = e.target.checked;
  
                    // Update leftLabel property
                    this.editElementProp('weight_required', 'checked', e);
  
                    // If unchecked, clear the text value
                    if (!isChecked) {
                      this.editElementProp('weight', 'value', { target: { value: '' } });
                    }
                  }
                }
                
                />
                    <label style={styles.labels} className="custom-control-label" htmlFor="is-overall_weight"> Overall weight? </label>
                {this.props.element.weight_required &&
                 
                  <input
                    type="number"
                    min={0}
                    max={100}
                    placeholder="Overall Weight"
                    style={styles.inputs}
                    value={this.state.element.weight === '' ? '' : this.state.element.weight}
                    onBlur={this.updateElement.bind(this)}
                    onChange={(e) => {
                      const rawValue = e.target.value;

                      
                      // Allow empty input
                      if (rawValue === '') {
                        this.editElementProp('weight', 'value', { target: { value: '' } });
                        return;
                      }

                      const value = parseInt(rawValue, 10);

                      // Only update if value is between 0 and 100
                      if (!Number.isNaN(value) && value >= 0 && value <= 100) {
                        this.editElementProp('weight', 'value', { target: { value } });
                      }
                    }}
                  />
                }
                  </div>}
          
          </div>
        }







        {/* { this.props.element.hasOwnProperty('label') &&
          <div className="form-group"> */}
        {/* <label> */}
        {/* <IntlMessages id="display-label" /> */}
        {/* Display label
              </label> */}
        {/* <Editor
              toolbar={toolbar}
              defaultEditorState={editorState}
              onBlur={this.updateElement.bind(this)}
              onEditorStateChange={this.onEditorStateChange.bind(this, 0, 'label')}
              stripPastedStyles={true} /> */}
        {/* <input type='text' defaultValue={this.props.element.label} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'label', 'value')} />
            <br />
            <div className="custom-control custom-checkbox">
              <input id="is-required" className="custom-control-input" type="checkbox" checked={this_checked} value={true} onChange={this.editElementProp.bind(this, 'required', 'checked')} />
              <label className="custom-control-label" htmlFor="is-required"> */}
        {/* <IntlMessages id="required" /> */}
        {/* required
              </label>
            </div> */}
        {/* { this.props.element.hasOwnProperty('readOnly') &&
              <div className="custom-control custom-checkbox">
                <input id="is-read-only" className="custom-control-input" type="checkbox" checked={this_read_only} value={true} onChange={this.editElementProp.bind(this, 'readOnly', 'checked')} />
                <label className="custom-control-label" htmlFor="is-read-only">
                <IntlMessages id="read-only" />
                </label>
              </div>
            }
            { this.props.element.hasOwnProperty('defaultToday') &&
              <div className="custom-control custom-checkbox">
                <input id="is-default-to-today" className="custom-control-input" type="checkbox" checked={this_default_today} value={true} onChange={this.editElementProp.bind(this, 'defaultToday', 'checked')} />
                <label className="custom-control-label" htmlFor="is-default-to-today">
                <IntlMessages id="default-to-today" />?
                </label>
              </div>
            }
            { this.props.element.hasOwnProperty('showTimeSelect') &&
              <div className="custom-control custom-checkbox">
                <input id="show-time-select" className="custom-control-input" type="checkbox" checked={this_show_time_select} value={true} onChange={this.editElementProp.bind(this, 'showTimeSelect', 'checked')} />
                <label className="custom-control-label" htmlFor="show-time-select">
                <IntlMessages id="show-time-select" />?
                </label>
              </div>
            }
            { this_show_time_select && this.props.element.hasOwnProperty('showTimeSelectOnly') &&
              <div className="custom-control custom-checkbox">
                <input id="show-time-select-only" className="custom-control-input" type="checkbox" checked={this_show_time_select_only} value={true} onChange={this.editElementProp.bind(this, 'showTimeSelectOnly', 'checked')} />
                <label className="custom-control-label" htmlFor="show-time-select-only">
                <IntlMessages id="show-time-select-only" />?
                </label>
              </div>
            }
            { this.props.element.hasOwnProperty('showTimeInput') &&
              <div className="custom-control custom-checkbox">
                <input id="show-time-input" className="custom-control-input" type="checkbox" checked={this_show_time_input} value={true} onChange={this.editElementProp.bind(this, 'showTimeInput', 'checked')} />
                <label className="custom-control-label" htmlFor="show-time-input">
                <IntlMessages id="show-time-input" />?
                </label>
              </div>
            }
            
            */}






        {/* { this.props.element.hasOwnProperty('src') &&
          <div>
            <div className="form-group">
              <label className="control-label" htmlFor="srcInput"><IntlMessages id="link-to" />:</label>
              <input id="srcInput" type="text" className="form-control" defaultValue={this.props.element.src} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'src', 'value')} />
            </div>
          </div>
        } */}
        {/* { canHaveImageSize &&
          <div>
            <div className="form-group">
              <div className="custom-control custom-checkbox">
                <input id="do-center" className="custom-control-input" type="checkbox" checked={this_checked_center} value={true} onChange={this.editElementProp.bind(this, 'center', 'checked')} />
                <label className="custom-control-label" htmlFor="do-center">
                <IntlMessages id="center" />?
                </label>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-3">
                <label className="control-label" htmlFor="elementWidth"><IntlMessages id="width" />:</label>
                <input id="elementWidth" type="text" className="form-control" defaultValue={this.props.element.width} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'width', 'value')} />
              </div>
              <div className="col-sm-3">
                <label className="control-label" htmlFor="elementHeight"><IntlMessages id="height" />:</label>
                <input id="elementHeight" type="text" className="form-control" defaultValue={this.props.element.height} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'height', 'value')} />
              </div>
            </div>
          </div>
        } */}
        {/* {this.state.element.element === 'FileUpload' && (
          <div>
            <div className='form-group'>
              <label className='control-label' htmlFor='fileType'>
                <IntlMessages id='choose-file-type' />:
              </label>
              <select
                id='fileType'
                className="form-control"
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(this, 'fileType', 'value')}
              >
                {[
                  {
                    type: 'image, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, video/mp4,video/x-m4v,video/*',
                    typeName: 'All File Type',
                  },
                  { type: 'image', typeName: 'Image' },
                  { type: 'application/pdf', typeName: 'PDF' },
                  {
                    type: 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    typeName: 'Word',
                  },
                  {
                    type: 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    typeName: 'Excel',
                  },
                  {
                    type: 'application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation',
                    typeName: 'Powerpoint',
                  },
                  {
                    type: 'video/mp4,video/x-m4v,video/*',
                    typeName: 'Videos',
                  },
                ].map((file, index) => (
                  <option value={file.type} key={index}>
                    {file.typeName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}
        {this.state.element.element === 'Signature' && this.props.element.readOnly
          ? (
            <div className="form-group">
              <label className="control-label" htmlFor="variableKey"><IntlMessages id="variable-key" />:</label>
              <input id="variableKey" type="text" className="form-control" defaultValue={this.props.element.variableKey} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'variableKey', 'value')} />
              <p className="help-block"><IntlMessages id="variable-key-desc" />.</p>
            </div>
          )
          : (<div/>)
        } */}

        {/* {canHavePageBreakBefore &&
          <div className="form-group">
            <label className="control-label"><IntlMessages id="print-options" /></label>
            <div className="custom-control custom-checkbox">
              <input id="page-break-before-element" className="custom-control-input" type="checkbox" checked={this_checked_page_break} value={true} onChange={this.editElementProp.bind(this, 'pageBreakBefore', 'checked')} />
              <label className="custom-control-label" htmlFor="page-break-before-element">
              <IntlMessages id="page-break-before-elements" />?
              </label>
            </div>
          </div>
        }

        {canHaveAlternateForm &&
          <div className="form-group">
            <label className="control-label"><IntlMessages id="alternate-signature-page" /></label>
            <div className="custom-control custom-checkbox">
              <input id="display-on-alternate" className="custom-control-input" type="checkbox" checked={this_checked_alternate_form} value={true} onChange={this.editElementProp.bind(this, 'alternateForm', 'checked')} />
              <label className="custom-control-label" htmlFor="display-on-alternate">
              <IntlMessages id="display-on-alternate-signature-page" />?
              </label>
            </div>
          </div>
        }
        { this.props.element.hasOwnProperty('step') &&
          <div className="form-group">
            <div className="form-group-range">
              <label className="control-label" htmlFor="rangeStep"><IntlMessages id="step" /></label>
              <input id="rangeStep" type="number" className="form-control" defaultValue={this.props.element.step} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'step', 'value')} />
            </div>
          </div>
        } */}
        {/* { this.props.element.hasOwnProperty('min_value') &&
          <div className="form-group">
            <div className="form-group-range">
              <label className="control-label" htmlFor="rangeMin"><IntlMessages id="min" /></label>
              <input id="rangeMin" type="number" className="form-control" defaultValue={this.props.element.min_value} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'min_value', 'value')} />
              <input type="text" className="form-control" defaultValue={this.props.element.min_label} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'min_label', 'value')} />
            </div>
          </div>
        }
        { this.props.element.hasOwnProperty('max_value') &&
          <div className="form-group">
            <div className="form-group-range">
              <label className="control-label" htmlFor="rangeMax"><IntlMessages id="max" /></label>
              <input id="rangeMax" type="number" className="form-control" defaultValue={this.props.element.max_value} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'max_value', 'value')} />
              <input type="text" className="form-control" defaultValue={this.props.element.max_label} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'max_label', 'value')} />
            </div>
          </div>
        } */}
        {/* { this.props.element.hasOwnProperty('default_value') &&
          <div className="form-group">
            <div className="form-group-range">
              <label className="control-label" htmlFor="defaultSelected"><IntlMessages id="default-selected" /></label>
              <input id="defaultSelected" type="number" className="form-control" defaultValue={this.props.element.default_value} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'default_value', 'value')} />
            </div>
          </div>
        }
        { this.props.element.hasOwnProperty('static') && this.props.element.static &&
          <div className="form-group">
            <label className="control-label"><IntlMessages id="text-style" /></label>
            <div className="custom-control custom-checkbox">
              <input id="do-bold" className="custom-control-input" type="checkbox" checked={this_checked_bold} value={true} onChange={this.editElementProp.bind(this, 'bold', 'checked')} />
              <label className="custom-control-label" htmlFor="do-bold">
              <IntlMessages id="bold" />
              </label>
            </div>
            <div className="custom-control custom-checkbox">
              <input id="do-italic" className="custom-control-input" type="checkbox" checked={this_checked_italic} value={true} onChange={this.editElementProp.bind(this, 'italic', 'checked')} />
              <label className="custom-control-label" htmlFor="do-italic">
              <IntlMessages id="italic" />
              </label>
            </div>
          </div>
        } */}
        {/* { this.props.element.showDescription &&
          <div className="form-group">
            <label className="control-label" htmlFor="questionDescription"><IntlMessages id="description" /></label>
            <TextAreaAutosize type="text" className="form-control" id="questionDescription" defaultValue={this.props.element.description} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'description', 'value')} />
          </div>
        } */}
        {/* { this.props.showCorrectColumn && this.props.element.canHaveAnswer && !this.props.element.hasOwnProperty('options') &&
          <div className="form-group">
            <label className="control-label" htmlFor="correctAnswer"><IntlMessages id="correct-answer" /></label>
            <input id="correctAnswer" type="text" className="form-control" defaultValue={this.props.element.correct} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'correct', 'value')} />
          </div>
        } */}
        {/* { this.props.element.canPopulateFromApi && this.props.element.hasOwnProperty('options') &&
          <div className="form-group">
            <label className="control-label" htmlFor="optionsApiUrl"><IntlMessages id="populate-options-from-api" /></label>
            <div className="row">
              <div className="col-sm-6">
                <input className="form-control" style={{ width: '100%' }} type="text" id="optionsApiUrl" placeholder="http://localhost:8080/api/optionsdata" />
              </div>
              <div className="col-sm-6">
                <button onClick={this.addOptions.bind(this)} className="btn btn-success"><IntlMessages id="populate" /></button>
              </div>
            </div>
          </div>
        } */}
        {this.props.element.hasOwnProperty('options') &&
          <DynamicOptionList
            // showCorrectColumn={this.props.showCorrectColumn}
            // canHaveOptionCorrect={canHaveOptionCorrect}
            // canHaveOptionValue={canHaveOptionValue}
            data={this.props.preview.state.data}
            updateElement={this.props.updateElement}
            preview={this.props.preview}
            element={this.props.element}
            key={this.props.element.options.length}
          />
        }

         {/* add custom only rating  START */}
        {
          (this.props.element.element === 'Rating') &&
            <div className='formrating'>

              <div className="custom-control custom-checkbox overall_weight">
                <input 
                id="is-overall_weight" 
                className="custom-control-input" 
                type="checkbox" 
                checked={this_checked_overAll_Weight} 
                value={true} 
                onChange={
                  // this.editElementProp.bind(this, 'weight_required', 'checked')
                  (e) => {
                    const isChecked = e.target.checked;
  
                    // Update leftLabel property
                    this.editElementProp('weight_required', 'checked', e);
  
                    // If unchecked, clear the text value
                    if (!isChecked) {
                      this.editElementProp('weight', 'value', { target: { value: '' } });
                    }
                  }
                }
                
                />
                <label style={styles.labels} className="custom-control-label" htmlFor="is-overall_weight"> Overall weight? </label>
                {this.props.element.weight_required &&
                  //   <input style={styles.inputs} type='text' placeholder='Overall Weight' defaultValue={this.props.element.labelTooltip} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'labelTooltip', 'value')} />}
                  // </div>
                  // <div className='overall_weight '>
                  //      <label style={styles.labels}>Overall weight:</label>
                  
                  

                  <input
                    type="number"
                    min={0}
                    max={100}
                    placeholder="Overall Weight"
                    style={styles.inputs}
                    value={this.state.element.weight === '' ? '' : this.state.element.weight}
                    onBlur={this.updateElement.bind(this)}
                    onChange={(e) => {
                      const rawValue = e.target.value;

                      
                      // Allow empty input
                      if (rawValue === '') {
                        this.editElementProp('weight', 'value', { target: { value: '' } });
                        return;
                      }

                      const value = parseInt(rawValue, 10);

                      // Only update if value is between 0 and 100
                      if (!Number.isNaN(value) && value >= 0 && value <= 100) {
                        this.editElementProp('weight', 'value', { target: { value } });
                      }
                    }}
                  />
                }
              </div>

            <div className="custom-control custom-checkbox">
              <input 
              id="is-leftLabel" 
              className="custom-control-input" 
              type="checkbox"  
              checked={this_checked_leftLabel} 
              value={true} 
              onChange={(e) => {
                        const isChecked = e.target.checked;

                        // Update leftLabel property
                        this.editElementProp('leftLabel', 'checked', e);

                        // If unchecked, clear the text value
                        if (!isChecked) {
                          this.editElementProp('leftLabelText', 'value', { target: { value: '' } });
                        }
                      }
                    // this.editElementProp.bind(this, 'leftLabel', 'checked')
                  } 
              />
              <label style={styles.labels} className="custom-control-label" htmlFor="is-leftLabel">
              {/* <IntlMessages id="tooltip" /> */}   Left Position Rating Label
              </label>
              { this.props.element.leftLabel  && <input style={styles.inputs} type='text' placeholder='Label ' value={this.props.element.leftLabelText || ''} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'leftLabelText', 'value')} />}
            </div>

            <div className="custom-control custom-checkbox">
              <input 
              id="is-centerLabel" 
              className="custom-control-input" 
              type="checkbox" checked={this_checked_centerLabel} 
              value={true} 
              onChange={
                  // this.editElementProp.bind(this, 'centerLabel', 'checked')
                  (e) => {
                    const isChecked = e.target.checked;

                    // Update leftLabel property
                    this.editElementProp('centerLabel', 'checked', e);

                    // If unchecked, clear the text value
                    if (!isChecked) {
                      this.editElementProp('centerLabelText', 'value', { target: { value: '' } });
                    }
                  }
              } 
              />
              <label style={styles.labels} className="custom-control-label" htmlFor="is-centerLabel">
              {/* <IntlMessages id="tooltip" /> */}   Center Position Rating Label
              </label>
              {this.props.element.centerLabel && <input style={styles.inputs} type='text' placeholder='Label ' value={this.props.element.centerLabelText || ''} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'centerLabelText', 'value')} />}
            </div>

            <div className="custom-control custom-checkbox">
              <input 
              id="is-rightLabel" 
              className="custom-control-input" 
              type="checkbox" 
              checked={this_checked_rightLabel} 
              value={true} 
              onChange={
                // this.editElementProp.bind(this, 'rightLabel', 'checked')
                (e) => {
                  const isChecked = e.target.checked;

                  // Update leftLabel property
                  this.editElementProp('rightLabel', 'checked', e);

                  // If unchecked, clear the text value
                  if (!isChecked) {
                    this.editElementProp('rightLabelText', 'value', { target: { value: '' } });
                  }
                }
              }

              />
              <label style={styles.labels} className="custom-control-label" htmlFor="is-rightLabel">
              {/* <IntlMessages id="tooltip" /> */}  Right Position Rating Label?
              </label>
              {this.props.element.rightLabel && <input style={styles.inputs} type='text' placeholder='Label ' value={this.props.element.rightLabelText || ''} onBlur={this.updateElement.bind(this)} onChange={this.editElementProp.bind(this, 'rightLabelText', 'value')} />}
            </div>

            </div>
        }
         {/*  add custom only rating END */}


      </div>
    );
  }
}
FormElementsEdit.defaultProps = { className: 'edit-element-fields' };